const ROW_ROUNDING = {
  0: "rounded-l-[12px]",
  3: "rounded-r-[12px]",
};

const GRID_CELL_CLASSES = [
  "border-b border-[#EFEFEF] sm:border-r",
  "border-b border-[#EFEFEF]",
  "border-b border-[#EFEFEF] sm:border-b-0 sm:border-r",
  "",
];

export const StatCard = ({
  idx,
  label,
  value,
  icon,
  iconBg = "bg-[#F8F8F8]",
  variant = "row",
}) => {
  const isGrid = variant === "grid";

  return (
    <div
      className={[
        "bg-white p-4 sm:px-6 flex items-center justify-between min-h-[96px] sm:min-h-[108px]",
        isGrid
          ? GRID_CELL_CLASSES[idx] ?? ""
          : `border border-[#EFEFEF] h-[108px] ${ROW_ROUNDING[idx] ?? ""}`,
      ].join(" ")}
      style={
        isGrid
          ? undefined
          : { borderRight: idx < 3 ? "1px solid #EAEAEA80" : undefined }
      }
    >
      <div className="min-w-0">
        <p className="text-[12px] sm:text-[13px] text-[#6B7280]">{label}</p>
        <p className="text-[18px] sm:text-[20px] font-semibold text-[#151515] mt-1 sm:mt-2">
          {value}
        </p>
      </div>
      <div
        className={`w-9 h-9 sm:w-10 sm:h-10 shrink-0 rounded-[10px] flex items-center justify-center ${iconBg}`}
      >
        <img src={icon} alt="" className="w-5 h-5 sm:w-auto sm:h-auto" />
      </div>
    </div>
  );
};
